import { App, getServerSideProps } from 'workspace'

function Workspace(props) {
  return <App {...props} />
}

export { getServerSideProps }
export default Workspace
